import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../../util';
import { Loader } from '../../util/Loader';
import userAccessProjectParticipationsService from '../../services/user_access_project_participations.service';
import userAccessBusinessUnitParticipationsService from '../../services/user_access_business_unit_participations.service';
export default function UnitsAndProjectsUserAccessesList(_ref) {
  let {
    userAccess,
    loading,
    setLoading,
    claimGroup,
    setClaimGroup
  } = _ref;
  const deleteUserAccessProjectParticipation = userAccessProjectParticipationsService.useDeleteUserAccessProjectParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const deleteUserAccessBussinessUnitParticilation = userAccessBusinessUnitParticipationsService.useDeleteUserAccessBusinessUnitParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const onDelete = async (index, row) => {
    if (row.data.participationType === 'business_unit') {
      return await deleteUserAccessBussinessUnitParticilation(userAccess, row.data.participation, row.data.participation.business_unit.id);
    } else {
      return await deleteUserAccessProjectParticipation(userAccess, row.data.participation, row.data.participation.claim_project_report.id);
    }
  };
  const {
    t
  } = useTranslation();
  const headers = [{
    text: t('permission_name')
  }, {
    text: t('type')
  }, {
    text: t('remove_access')
  }];
  const rows = [...(userAccess.user_access_business_unit_participations || []).map(bu_particilation => ({
    data: {
      participationType: 'business_unit',
      participation: bu_particilation
    },
    key: bu_particilation.id,
    columns: [bu_particilation.business_unit.name, t('business_unit')]
  })), ...(userAccess.user_access_project_participations || []).map(project_particilation => ({
    data: {
      participationType: 'project',
      participation: project_particilation
    },
    key: project_particilation.id,
    columns: [project_particilation.claim_project_report.project_name, t('project')]
  }))];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, t('current_access')), loading && /*#__PURE__*/React.createElement(Loader, null), !loading && /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    onDelete: onDelete
  }));
}